export default __webpack_public_path__ + "static/media/rightarr.4cc54352.png";